import { t } from "../../../languages";

const ShowStudentResult = ({ lang, response, points = null, inPodium = false }) => {
    // console.log('ShowStudentResult response:', response, Object.keys(response));
    return <div className='student-answer'>
        <h2>{t(lang, 'youranswer')}</h2>
        {(response && Object.keys(response).length) ? <p className={`message ${response.p ? 'valid' : 'error'}`}>
            {response.p ? t(lang, 'goodchallengeanswer') : t(lang, 'badchallengeanswer')}
        </p> : <p className={`message error`}>
            {t(lang, 'nochallengeanswer')}
        </p>}

        {points ? <div className="points"><img src="./static/myspace/coin.svg" alt="" /> {points}</div> : null}

        {inPodium ? <div className="inpodium">{t(lang, 'yourareinpodium')}</div> : null}

    </div>;
}

export default ShowStudentResult;